import { default as StepperComponent } from "./stepper.js";
import StepperButton from "./stepper-button.js";
import StepperInput from "./stepper-input.js";
const Stepper = StepperComponent;
Stepper.Input = StepperInput;
Stepper.Button = StepperButton;
export default Stepper;
